// extracted by mini-css-extract-plugin
module.exports = {"page-primary-color":"#021135","pagePrimaryColor":"#021135","page-secondary-color":"#FFFFFF","pageSecondaryColor":"#FFFFFF","rail":"_3vXgb","item":"_24UPU"};